/* eslint-disable no-param-reassign */
import { GraphQLRequest, HttpLink, execute, toPromise } from '@apollo/client';
import { datadogLogs } from '@datadog/browser-logs';
import axios from 'axios';

import {
  getAuthorizationTokens,
  getExports,
  getStrapiJWTToken,
  getStrapiEndpoint,
} from 'services';

const api = axios.create({
  timeout: 20000,
});

api.interceptors.request.use(
  async request => {
    const endpoints = await getExports();
    request.baseURL = `${endpoints.arkhamApiURL}`;

    if (!request?.headers?.Authorization) {
      try {
        const { accessToken } = await getAuthorizationTokens();
        if (accessToken) {
          request.headers = {
            ...request.headers,
            Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            Authorization: `Bearer ${accessToken}`,
          };
        }
      } catch {
        // do nothing
      }
    }
    return request;
  },
  error => {
    Promise.reject(error);
  },
);

const strapi = axios.create({
  timeout: 20000,
});

async function executeApollo(option: GraphQLRequest) {
  const strapiEndpoint = await getStrapiEndpoint();
  const strapiJWT = await getStrapiJWTToken();

  const link = new HttpLink({ uri: `${strapiEndpoint}/graphql` });

  return toPromise(
    execute(link, {
      ...option,
      context: {
        ...option.context,
        headers: {
          ...option.context?.headers,
          Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          Authorization: `Bearer ${strapiJWT}`,
        },
      },
    }),
  );
}

const caishenApi = axios.create({ timeout: 5000 });

caishenApi.interceptors.request.use(
  async config => {
    const endpoints = await getExports();
    config.baseURL = endpoints.caishenApiUrl;

    if (!config?.headers?.Authorization) {
      const { accessToken } = await getAuthorizationTokens();
      try {
        if (accessToken) {
          config.headers = {
            Authorization: `Bearer ${accessToken}`,
          };
        }
      } catch (e) {
        datadogLogs.logger.error(
          '[caishenApi] Error getting authorization token',
          {
            error: e,
          },
        );
      }
    }
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

export { api, caishenApi, strapi, executeApollo };
